module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-22.f2473768.png";